"use strict";

var _toConsumableArray = require("/Users/ryan/Documents/GitHub/vz-logger/frontend/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isIterable(obj) {
  if (obj === null || obj === undefined) return false;
  return typeof obj[Symbol.iterator] === 'function';
}

exports.isIterable = isIterable;

function setIntersection(x, y) {
  var intersection = new Set();

  if (x.size < y.size) {
    x.forEach(function (elem) {
      if (y.has(elem)) intersection.add(elem);
    });
  } else {
    y.forEach(function (elem) {
      if (x.has(elem)) intersection.add(elem);
    });
  }

  return intersection;
}

exports.setIntersection = setIntersection;

function setUnion(x, y) {
  var union = new Set([].concat(_toConsumableArray(x), _toConsumableArray(y)));
  return union;
}

exports.setUnion = setUnion;